import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'
import { BoVisitor } from './bo-visitor.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { VariableDefinition } from '../script/variable-definition.js'
import { RestrictableItem } from './restrictions/restrictable-item.js'
import { Parameter } from '../script/parameter.js'
import { Code } from '../data/text-or-code.js'
import { TextOrCode } from '../data/text-or-code.js'
import type { ProcessTokenScope } from '../types.js'

// IdTypes is exported from entity.ts
interface SignalRef {
	id: string
	name: string
}
interface MessageRef extends SignalRef {
	$attrs?: { 'lowgile:tsType': string }
}

interface EventDefinition {
	$type: string
	timeCycle?: { body: string }
	timeDate?: { body: string }
	timeDuration?: { body: string }
	signalRef?: SignalRef
	messageRef?: MessageRef
	$attrs?: {
		'lowgile:messageDataHandler'?: string
		'lowgile:messageDataProducer'?: string
	}
}
export interface ProcessActivity {
	id: string
	name: string
	$type: string
	eventDefinitions?: EventDefinition[]
	outgoing: ProcessSequenceFlow[]
	incoming: ProcessSequenceFlow[]
	default?: ProcessSequenceFlow
}
;[]
export interface ProcessLane extends ProcessActivity {
	$attrs: { 'lowgile:assigneeExpression': string }
	flowNodeRef: ProcessActivity[]
}
;[]
export interface ProcessScriptTask extends ProcessActivity {
	script: string
}
;[]
export interface ProcessUserTaskAssignment {
	$type?: 'lowgile:UserTaskAssignment'
	variableName: string
	expression: string
}
export interface ProcessUserTaskOutputHandler {
	$type?: 'lowgile:UserTaskOutputHandler'
	outputName: string
	code: string
}
export type ProcessUserTaskExtensionElement =
	| ProcessUserTaskAssignment
	| ProcessUserTaskOutputHandler
export interface ProcessUserTask extends ProcessActivity {
	$type: 'bpmn:UserTask'
	$attrs: {
		'lowgile:screenRef': string
		'lowgile:isPreferred': `${boolean}`
		'lowgile:priority': `${number}`
		'lowgile:isAutoAssign': `${boolean}`
		'lowgile:onArrivalCode': string
	}
	businessObject: { screenRef: string }
	extensionElements: { values: ProcessUserTaskExtensionElement[] }
}
;[]
export interface ProcessSequenceFlow extends ProcessActivity {
	conditionExpression?: { body: string }
	sourceRef: ProcessActivity
	targetRef: ProcessActivity
	$attrs: { 'lowgile:onTakeCode': string }
}
;[]

export const DefaultProcessXml =
	'<?xml version="1.0" encoding="UTF-8"?>\n<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:lowgile="http://lowgile.com/bpmn" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn">\n  <bpmn:collaboration id="Collaboration_18ads8h">\n    <bpmn:participant id="Participant_12z0rmv" processRef="Process_1" />\n  </bpmn:collaboration>\n  <bpmn:process id="Process_1" isExecutable="true">\n    <bpmn:laneSet id="LaneSet_0vl757h">\n      <bpmn:Lane id="Lane_01mj2t0" name="Initiator" lowgile:assigneeExpression="return {\n\tusers: [initiator],\n}">\n        <bpmn:flowNodeRef>StartEvent_1</bpmn:flowNodeRef>\n        <bpmn:flowNodeRef>Event_0fe9mh4</bpmn:flowNodeRef>\n        <bpmn:flowNodeRef>Activity_0py37yy</bpmn:flowNodeRef>\n      </bpmn:Lane>\n      <bpmn:Lane id="Lane_0o5ug4y" />\n    </bpmn:laneSet>\n    <bpmn:startEvent id="StartEvent_1">\n      <bpmn:outgoing>Flow_17w17rd</bpmn:outgoing>\n    </bpmn:startEvent>\n    <bpmn:endEvent id="Event_0fe9mh4">\n      <bpmn:incoming>Flow_0jxedjr</bpmn:incoming>\n    </bpmn:endEvent>\n    <bpmn:sequenceFlow id="Flow_17w17rd" sourceRef="StartEvent_1" targetRef="Activity_0py37yy" />\n    <bpmn:sequenceFlow id="Flow_0jxedjr" sourceRef="Activity_0py37yy" targetRef="Event_0fe9mh4" />\n    <bpmn:scriptTask id="Activity_0py37yy" name="Hello World">\n      <bpmn:incoming>Flow_17w17rd</bpmn:incoming>\n      <bpmn:outgoing>Flow_0jxedjr</bpmn:outgoing>\n      <bpmn:script>console.log(\'Hello world\')</bpmn:script>\n    </bpmn:scriptTask>\n  </bpmn:process>\n  <bpmndi:BPMNDiagram id="BPMNDiagram_1">\n    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Collaboration_18ads8h">\n      <bpmndi:BPMNShape id="Participant_12z0rmv_di" bpmnElement="Participant_12z0rmv" isHorizontal="true">\n        <dc:Bounds x="140" y="20" width="600" height="370" />\n      </bpmndi:BPMNShape>\n      <bpmndi:BPMNShape id="Lane_0o5ug4y_di" bpmnElement="Lane_0o5ug4y" isHorizontal="true">\n        <dc:Bounds x="170" y="250" width="570" height="140" />\n      </bpmndi:BPMNShape>\n      <bpmndi:BPMNShape id="Lane_01mj2t0_di" bpmnElement="Lane_01mj2t0" isHorizontal="true">\n        <dc:Bounds x="170" y="20" width="570" height="230" />\n        <bpmndi:BPMNLabel />\n      </bpmndi:BPMNShape>\n      <bpmndi:BPMNShape id="Event_0wkplut_di" bpmnElement="StartEvent_1">\n        <dc:Bounds x="222" y="122" width="36" height="36" />\n      </bpmndi:BPMNShape>\n      <bpmndi:BPMNShape id="Event_0fe9mh4_di" bpmnElement="Event_0fe9mh4">\n        <dc:Bounds x="642" y="122" width="36" height="36" />\n      </bpmndi:BPMNShape>\n      <bpmndi:BPMNShape id="Activity_1pxzdgm_di" bpmnElement="Activity_0py37yy">\n        <dc:Bounds x="320" y="100" width="100" height="80" />\n        <bpmndi:BPMNLabel />\n      </bpmndi:BPMNShape>\n      <bpmndi:BPMNEdge id="Flow_17w17rd_di" bpmnElement="Flow_17w17rd">\n        <di:waypoint x="258" y="140" />\n        <di:waypoint x="320" y="140" />\n      </bpmndi:BPMNEdge>\n      <bpmndi:BPMNEdge id="Flow_0jxedjr_di" bpmnElement="Flow_0jxedjr">\n        <di:waypoint x="420" y="140" />\n        <di:waypoint x="642" y="140" />\n      </bpmndi:BPMNEdge>\n    </bpmndi:BPMNPlane>\n  </bpmndi:BPMNDiagram>\n</bpmn:definitions>\n'

@jsonClass('Process')
export class Process extends BusinessObject {
	@jsonProperty(String)
	definitionXml: string = ''

	@jsonArrayProperty(VariableDefinition)
	processVariableDefinitions: VariableDefinition[] = []

	@jsonArrayProperty(VariableDefinition)
	tokenVariableDefinitions: VariableDefinition[] = []

	@jsonProperty(Code)
	onSettledCode: Code = new Code()
	@jsonProperty(Code)
	beforeResumeCode: Code = new Code()

	// @jsonMapProperty(String, ProcessScriptConfig)
	// scriptConfigs = new Map<string, ProcessScriptConfig>()

	// @jsonMapProperty(String, ProcessScreenConfig)
	// screenConfigs = new Map<string, ProcessScreenConfig>()

	// @jsonMapProperty(String, ProcessFlowConfig)
	// flowConfigs = new Map<string, ProcessFlowConfig>()

	constructor(init?: Partial<Process>) {
		super()
		assignCommonProperties(this, init)
	}

	// getScriptConfig(elementId: string) {
	// 	let config = this.scriptConfigs.get(elementId)
	// 	if(!config) {
	// 		config = new ProcessScriptConfig()
	// 		this.scriptConfigs.set(elementId, config)
	// 	}
	// 	return config
	// }

	// getScreenConfig(elementId: string) {
	// 	let config = this.screenConfigs.get(elementId)
	// 	if(!config) {
	// 		config = new ProcessScreenConfig()
	// 		this.screenConfigs.set(elementId, config)
	// 	}
	// 	return config
	// }

	// getFlowConfig(elementId: string) {
	// 	let config = this.flowConfigs.get(elementId)
	// 	if(!config) {
	// 		config = new ProcessFlowConfig()
	// 		this.flowConfigs.set(elementId, config)
	// 	}
	// 	return config
	// }

	visit(visitor: BoVisitor): void {
		// this.scriptConfigs.forEach((config, key) => config.visit(visitor, ['scriptConfigs', key]))
		// this.screenConfigs.forEach((config, key) => config.visit(visitor, ['screenConfigs', key]))
		// this.flowConfigs.forEach((config, key) => config.visit(visitor, ['flowConfigs', key]))
	}

	getVariableScope(
		includeDeclarationVariables: boolean,
		forSpecialUse?: 'assignmentExpression',
	): Partial<Record<keyof ProcessTokenScope, string>> {
		const variables: Partial<Record<keyof ProcessTokenScope, string>> = {
			process: `This.$Process.${this.boId}.ProcessData`,
			initiator: 'Sys.Types.User | null',
		}

		if (forSpecialUse != 'assignmentExpression') {
			variables.token = `{ ${this.tokenVariableDefinitions.map((vd) => vd.getSignature(false, false)).join(', ')} }`
			variables.action = 'string'
			variables.swimlane = 'Sys.Types.Swimlane'
		}

		return variables
	}

	getClassNames(): string[] {
		return [`$Process.${this.boId}`]
	}

	getRestrictableItems(): RestrictableItem[] {
		return [
			new RestrictableItem({
				itemName: 'start',
				parameters: [
					new Parameter({
						name: 'inputData',
						type: `${this.moduleId}.$Process.${this.boId}.ProcessInputData`,
					}),
					new Parameter({
						name: 'accessController',
						type: `ProcessAccessController`,
					}),
				],
				contextImports: {
					ProcessAccessController: '@lg/shared',
				},
			}),
		]
	}
}
